


























import {Emit, Prop, Ref, Vue, VModel, Component, Watch} from "vue-property-decorator";

export class CustomDropdownValue<T> {
    public value: T|null = null;
    public isCustom = false;

    constructor(value: T|null = null, isCustom = false) {
        this.value = value;
        this.isCustom = isCustom;
    }
}

@Component
export default class CustomDropdown<T> extends Vue {
    @Ref("selectInput")
    selectInput!: HTMLSelectElement;

    @Ref("customInput")
    customInput!: HTMLInputElement;

    @VModel({type: CustomDropdownValue, required: true})
    private selectedValue!: CustomDropdownValue<T>;

    @Prop({required: true})
    private options!: T[];

    @Prop({default: null})
    private defaultValue!: T|null;

    private internalValue: T|null = null;
    private isCustomValue = false;

    private mounted() {
        this.internalValue = this.selectedValue.value;
        this.isCustomValue = this.selectedValue.isCustom;
    }

    @Watch("selectedValue", {deep: true})
    private valueChanged() {
        this.internalValue = this.selectedValue.value;
        this.isCustomValue = this.selectedValue.isCustom;
        this.$forceUpdate();
    }

    private change() {
        this.selectedValue.value = this.internalValue;
        this.selectedValue.isCustom = this.isCustomValue;
        this.$emit("input", this.selectedValue);
        this.$emit("change", this.selectedValue);
        return this.selectedValue;
    }

    private handleSelectInput() {
        this.triggerChange();
    }

    private handleSelectChange(event: InputEvent) {
        if (this.selectInput.value === "__CUSTOM__") {
            event.preventDefault();
            this.internalValue = this.defaultValue;
            this.isCustomValue = true;
            this.triggerChange();
            setTimeout(() => this.customInput.focus(), 2);
        }
    }

    private handleCustomChange() {
        this.triggerChange();
    }

    private triggerChange() {
        setTimeout(() => this.change(), 1);
    }
}

